import { useAtomValue } from 'user-auth/libs/jotai'

import { auth, AuthState } from 'user-auth/states/auth'

export const useAuth = () => useAtomValue(auth) as AuthState
